<template>
    <div class="page-parking-cards">
        <el-card shadow="never" class="m-b-20">
            <el-row :gutter="20">
                <el-col :sm="24" :md="12" :lg="16" :xl="16" class="m-b-10 m-b-md-0">
                    <el-input placeholder="Поиск по карте"
                              v-model="form.SearchString"
                              v-on:change="getData"
                              clearable>
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                </el-col>
                <el-col :sm="24" :md="6" :lg="4" :xl="4" align="center" class="m-b-10 m-b-md-0">
                    <el-switch @change="changeAutoUpdate" v-model="form.autoUpdate" active-text="Автообновление" class="m-b-10 m-b-md-0 m-t-10"></el-switch>
                </el-col>
                <el-col :sm="24" :md="6" :lg="4" :xl="4">
                    <el-button class="w-100" type="primary" @click="handleFilter" icon="icon-search">Поиск</el-button>
                </el-col>
                <!--
                <el-col :sm="24" :md="8" :lg="8" :xl="6" align="right" class="d-flex m-t-10 m-t-md-0">
                    <el-button class="w-50" @click="exportCSV" icon="icon-csv-file">{{ ($mobile() ? 'Экспорт ' : '') + 'CSV' }}</el-button>
                    <el-button class="w-50" @click="exportCSV" icon="icon-xls-file">{{ ($mobile() ? 'Экспорт ' : '') + 'Excel' }}</el-button>
                </el-col>
                -->
            </el-row>
        </el-card>
        <el-row :gutter="20">
            <el-col :span="24">
                <el-table v-loading="loading" :data="dataTable" :row-class-name="tableRowClassName">
                    <el-table-column prop="Blocked" label="Статус" min-width="130px" sortable>
                        <template slot-scope="scope">
                            <el-tag
                                    class="boolean"
                                    :type="scope.row.Blocked ? 'danger' : 'success'"
                                    close-transition
                            >
                                {{ (scope.row.Blocked ? 'Заблокирована' : 'Работает')}}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Card" label="Карта" min-width="110px" sortable>
                        <template slot-scope="scope">
                            <div class="font-weight-bold">
                                {{scope.row.Name}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="$mobile()" prop="TimeEntry" label="Время въезда" min-width="140px" sortable>
                        <template slot-scope="scope">
                            <table-date :date="scope.row.TimeEntry"/>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="$mobile()" prop="Zone" label="Зона" sortable />
                    <el-table-column v-if="$mobile()" prop="Type" label="Тип клиента" min-width="130px" sortable />
                    <el-table-column prop="Customer" label="Клиент" min-width="90px" />
                    <el-table-column v-if="$mobile()" prop="Company" label="Организация" min-width="120px" />
                    <el-table-column v-if="$mobile()" prop="TimeExpiration" label="Срок действия карты" min-width="190px" sortable>
                        <template slot-scope="scope">
                            <table-date :date="scope.row.TimeExpiration"/>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="$mobile()" prop="Tariff" label="Тариф" />
                    <el-table-column v-if="$mobile()" prop="PlateEntry" label="Номер на въезде" min-width="140px" />
                    <el-table-column
                            fixed="right"
                            label="Действия"
                            width="125px"
                            align="right"
                    >
                        <template slot-scope="scope">
                            <el-button @click="block(scope.row.ID)" icon="el-icon-close" class="m-l-10 float-right el-button--icon" size="mini" title="Заблокировать"></el-button>
                            <el-button @click="takeOut(scope.row.ID)" type="danger" icon="icon-checkout" class="float-right el-button--icon" size="mini" title="Вывести с парковки"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="m-t-20 text-center">
                    <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="form.Page"
                            :page-sizes="[10, 20, 100, 200, 300, 400]"
                            :page-size="form.PageSize"
                            layout="sizes, prev, pager, next, total"
                            :total="total">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import { mapMutations, mapGetters } from 'vuex'

    export default {
        data () {
            return {
                loading: false,
                form: {
                    autoUpdate: true,
                    SearchString: '',
                    Page: 1,
                    PageSize: 20
                },
                timer: null,
                total: 0,
                dataTable: []
            }
        },
        computed: {
            ...mapGetters(['initCondition'])
        },
        beforeDestroy () {
            clearInterval(this.timer)
        },
        created () {
            this.form = this.initCondition({model: this.form})
            this.getData()
            if (this.form.autoUpdate) {
                this.activateTimer()
            }
        },
        methods: {
            ...mapMutations(['setCondition']),
            activateTimer () {
                this.timer = setInterval(() => {
                    this.getData(1)
                    if (this.timer < 1) {
                        clearInterval(this.timer)
                    }
                }, 5000)
            },
            changeDate (date) {
                this.form.From = date[0]
                this.form.To = date[1]
                this.getData()
            },
            handleSizeChange (val) {
                this.form.PageSize = val
                this.getData()
            },
            handleCurrentChange (val) {
                this.form.Page = val
                this.getData()
            },
            handleFilter () {
                this.getData()
            },
            changeAutoUpdate (val) {
                if (val) {
                    this.activateTimer()
                }
                else {
                    clearInterval(this.timer)
                }
            },
            getData () {
                this.setCondition({ model: this.form })
                this.loading = true

                let request = Object.assign({
                    Name: "GetItemsList",
                    ItemType: "ParkingCard"
                }, this.form)

                this.$api.Main.getParkingCards(request).then(response => {
                    this.loading = false
                    this.dataTable = response.Items
                    this.total = response.Total
                }).catch (() => {
                    this.loading = false
                })
            },
            showDetails (id) {
                this.$router.push({ name: 'carDetails', params: { id: id } })
            },
            tableRowClassName({row}) {
                if (!row.Deactivated) {
                    return 'success-row';
                } else {
                    return 'warning-row';
                }
            },
            takeOut (id) {
                this.$confirm('Вы уверены что хотите вывести карту с парковки?').then(() => {
                    let request = {
                        Name: "",
                        ItemType: "Card",
                        ItemId: id
                    }

                    this.$api.Main.takeOutCard(request).then(response => {
                        if (response.Result === 'Failed') {
                            this.$message({
                                message: response.ErrorString,
                                type: 'error'
                            })
                        }
                        else {
                            this.$message({
                                message: 'Карта выведена с парковки',
                                type: 'success',
                                res: response
                            })
                            this.getData()
                        }
                    })
                })
            },
            block (id) {
                this.$confirm('Вы уверены что хотите заблокировать карту?').then(() => {
                    let request = {
                        Name: "",
                        ItemType: "Card",
                        ItemId: id
                    }

                    this.$api.Main.blockCard(request).then(response => {
                        if (response.Result === 'Failed') {
                            this.$message({
                                message: response.ErrorString,
                                type: 'error'
                            })
                        }
                        else {
                            this.$message({
                                message: 'Карта заблокирована',
                                type: 'success',
                                res: response
                            })
                            this.getData()
                        }
                    })
                })
            },
            exportCSV () {

            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
